export default __webpack_public_path__ + "static/media/hm-gp-img.6f4e415c.webp";